import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getApplicantCareerRoles() {
  return await prisma.applicantCareerRole.findMany({
    orderBy: { id: Prisma.SortOrder.asc },
  });
}
